export enum RenderClearFlag{
    Nothing = 0,
    Color = 1,
    Depth = 2,
    Stencil = 4,
}